import { error as errorReducer } from './Error.reducer';
import {
    STATEMENTS_RECEIVE,
    STATEMENTS_ERROR
} from '../Actions/Statements.action';

const defaultState = {
    errors: {}
};

export const statements = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case STATEMENTS_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case STATEMENTS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
